import mParticleSdk from '@mparticle/web-sdk'
import { useInternalAnalytics } from '../../../utils/internalAnalytics'
import { makeMParticleGlobalProperties } from '../../../utils/internalAnalytics/internalAnalyticsUtils'

function useTrackEvent(): typeof mParticleSdk.logEvent {
  const { mParticle, consentSynced } = useInternalAnalytics()

  return (eventName, eventType, eventInfo, customFlags, eventOptions) => {
    if (!mParticle || !consentSynced) {
      return
    }

    const eventInfoWithGlobalProperties: mParticleSdk.SDKEventAttrs = {
      ...eventInfo,
      ...makeMParticleGlobalProperties(mParticle),
    }

    mParticle.logEvent(
      eventName,
      eventType,
      eventInfoWithGlobalProperties,
      customFlags,
      eventOptions,
    )
  }
}

export default useTrackEvent
